<div class="fc-loading-container">
  <div class="fc-loading">
    <div class="fc-loading__spinner">
      <svg viewBox="0 0 84 84">
        <rect x="2" y="2" width="80" height="80"/>
      </svg>
    </div>
    <div class="fc-loading__icon">
      <app-icon [icon]="Icons.logo"/>
    </div>
  </div>
</div>
